import React from 'react'
import { KTIcon } from '../../../_metronic/helpers'

const PAGE_SIZE_OPTIONS = [10, 25, 50]

interface CursorPaginationProps {
  pageSize: number
  pageSizeOptions?: number[]
  canGoBack: boolean
  canGoForward: boolean
  onBack: () => void
  onForward: () => void
  onPageSizeChange: (size: number) => void
}

/**
 * Курсорная пагинация «Назад / Вперёд» + селект размера страницы
 * (CPAYMENT-1739). Существующий `TablePagination` — страничный
 * (offset/page), для курсорного API ledger не подходит.
 */
export const CursorPagination: React.FC<CursorPaginationProps> = ({
  pageSize,
  pageSizeOptions = PAGE_SIZE_OPTIONS,
  canGoBack,
  canGoForward,
  onBack,
  onForward,
  onPageSizeChange,
}) => {
  return (
    <div className='d-flex align-items-center justify-content-between flex-wrap gap-3 pt-5'>
      <div className='d-flex align-items-center gap-2'>
        <label htmlFor='cursor-pagination-page-size' className='text-muted fs-7 mb-0'>
          Записей на странице
        </label>
        <select
          id='cursor-pagination-page-size'
          aria-label='Записей на странице'
          className='form-select form-select-sm w-auto'
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
        >
          {pageSizeOptions.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </div>
      <div className='d-flex gap-2'>
        <button
          type='button'
          className='btn btn-sm btn-light'
          disabled={!canGoBack}
          onClick={onBack}
        >
          <KTIcon iconName='arrow-left' className='fs-4 me-1' />
          Назад
        </button>
        <button
          type='button'
          className='btn btn-sm btn-light'
          disabled={!canGoForward}
          onClick={onForward}
        >
          Вперёд
          <KTIcon iconName='arrow-right' className='fs-4 ms-1' />
        </button>
      </div>
    </div>
  )
}
